import Vue from "vue"

// #region DIRECTIVES AND PLUGINS
// On page edit plugin that enables that exposes the computed isEditable variable on all vue instances
import OnPageEditPlugin from "@/vue/plugins/onPageEditPlugin"
Vue.use(OnPageEditPlugin)

// On page edit, v-edit directive
import { edit } from "@/vue/directives/v-edit"
import { noedit } from "@/vue/directives/v-no-edit"

Vue.directive("no-edit", (...params) => {
  if (params[0] instanceof HTMLElement) {
    //When used by clientside js
    noedit(params[2], params[1])
  } else {
    //When used by serverside nodejs
    noedit(...params)
  }
})

Vue.directive("edit", (...params) => {
  if (params[0] instanceof HTMLElement) {
    //When used by clientside js
    edit(params[2], params[1])
  } else {
    //When used by serverside nodejs
    edit(...params)
  }
})

// Scrolling by mouse or touch
import VueDragscroll from "vue-dragscroll"
Vue.use(VueDragscroll)
// #endregion

// #region VUE COMPONENTS
// Common external components
import SvgIcon from "vue-svgicon"
// import "@/vue/components/icons"
Vue.use(SvgIcon)



// Social sharing vue
import SocialSharing from "vue-social-sharing"
Vue.use(SocialSharing)

import NoSSR from "vue-no-ssr"
Vue.component("NoSsr", NoSSR)

import LoginPlugin from "~/@ica/ica-molecules-vue/dist/plugins/loginPlugin"
Vue.use(LoginPlugin) // Will register this.$ICALogin

// Common components
import ImageVideoComponent from "@/vue/components/common/imageVideoComponent"
import OnPageBreadcrumbs from "@/vue/components/common/on-page-breadcrumbs"
import EpiProperty from "@/vue/components/editorial/epiProperty"
import EpiPicture from "@/vue/components/common/picture/epiPicture"
import CloudinaryPicture from "@/vue/components/common/picture/cloudinaryPicture"
import CustomTinyMceAdaptiveImageBlock from "@/vue/components/common/picture/customTinyMceAdaptiveImageBlock"
import BlockGrid from "@/vue/components/BlockGrid/blockGrid"
import Wysiwyg from "@/vue/components/common/wysiwyg"
import IcaAccordionGroup from "@/vue/components/common/accordionGroup"
import InView from "@/vue/components/common/InView"
import SubHeading from "@/vue/components/common/subHeading"
Vue.component("ImageVideoComponent", ImageVideoComponent)
Vue.component("BlockGrid", BlockGrid)
Vue.component("OnPageBreadcrumbs", OnPageBreadcrumbs)
Vue.component("EpiProperty", EpiProperty)
Vue.component("EpiPicture", EpiPicture)
Vue.component("CloudinaryPicture", CloudinaryPicture)
Vue.component("CustomTinyMceAdaptiveImageBlock", CustomTinyMceAdaptiveImageBlock)
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Wysiwyg", Wysiwyg)
Vue.component("InView", InView)
Vue.component("SubHeading", SubHeading)
Vue.component("AccordionGroup", IcaAccordionGroup)

// components copied from Molecules
import IcaRecipe from "@/vue/components/recipes/recipeCardWrapper.vue"
import IcaRecipeCollectionBlock from "@/vue/components/molecules/RecipeCollectionCard"
import IcaArticle from "@/vue/components/molecules/ArticleBlock"
Vue.component("RecipeBlock", IcaRecipe)
Vue.component("RecipeCollectionBlock", IcaRecipeCollectionBlock)
Vue.component("ArticleBlock", IcaArticle)

// Pages
import LandingPage from "@/vue/pages/landingPage/landingPage"
import InfoPage from "@/vue/pages/infoPage/infoPage"
import OverviewPage from "@/vue/pages/overviewPage/overviewPage"
import ErrorPage from "@/vue/pages/errorPage/errorPage"
import NoticePage from "@/vue/pages/noticePage/noticePage"
import ArticlePage from "@/vue/pages/articlePage/articlePage"
import CampaignPage from "@/vue/pages/campaignPage/campaignPage"
import CustomerServicePage from "@/vue/pages/customerServicePage/customerServicePage"
import FaqCollectionPage from "@/vue/pages/faqCollectionPage/faqCollectionPage"
import NewslistPage from "@/vue/pages/newslistPage/newslistPage"
import GroceryBagLandingPage from "@/vue/pages/groceryBagLandingPage/groceryBagLandingPage"
import GroceryBagOverviewPage from '@/vue/pages/groceryBagOverviewPage/groceryBagOverviewPage'
import PoliciesOverviewPage from "@/vue/pages/policiesOverviewPage/policiesOverviewPage"
import PoliciesInfoPage from "@/vue/pages/policiesInfoPage/policiesInfoPage"
import CategoryPage from '@/vue/pages/categoryPage/categoryPage'
import EntrancePage from '@/vue/pages/entrancePage/entrancePage'

Vue.component("LandingPage", LandingPage)
Vue.component("InfoPage", InfoPage)
Vue.component("OverviewPage", OverviewPage)
Vue.component("ErrorPage", ErrorPage)
Vue.component("NoticePage", NoticePage)
Vue.component("ArticlePage", ArticlePage)
Vue.component("CampaignPage", CampaignPage)
Vue.component("CustomerServicePage", CustomerServicePage)
Vue.component("FaqCollectionPage", FaqCollectionPage)
Vue.component("NewslistPage", NewslistPage)
Vue.component("GroceryBagLandingPage", GroceryBagLandingPage)
Vue.component("GroceryBagOverviewPage", GroceryBagOverviewPage)
Vue.component("PoliciesOverviewPage", PoliciesOverviewPage)
Vue.component("PoliciesInfoPage", PoliciesInfoPage)
Vue.component("CategoryPage", CategoryPage)
Vue.component("EntrancePage", EntrancePage)

import StartPage from '@/vue/pages/startPage/startPage'
Vue.component("StartPage", StartPage)

// Blocks
import UspBlock from "@/vue/blocks/UspBlock/uspBlock"
import HeroBlock from "@/vue/blocks/HeroBlock/heroBlock"
import NavigationBlock from "@/vue/blocks/NavigationBlock/navigationBlock"
import NavigationGroupBlock from "@/vue/blocks/NavigationGroupBlock/navigationGroupBlock"
import TitleTextBlock from "@/vue/blocks/TitleTextBlock/titleTextBlock"
import ConversionBlock from "@/vue/blocks/ConversionBlock/conversionBlock"
import OverviewNavigationBlock from "@/vue/blocks/OverviewNavigationBlock/overviewNavigationBlock"
import IllustrativeLinksBlock from "@/vue/blocks/IllustrativeLinksBlock/illustrativeLinksBlock"
import OfferBlock from "@/vue/blocks/OfferBlock/offerBlock"
import PromoteProductBlock from "@/vue/blocks/PromoteProductBlock/promoteProductBlock"
import ProductBlock from "@/vue/blocks/ProductBlock/productBlock"
import FactBlock from '@/vue/blocks/FactBlock/factBlock'
import ImageTextBlock from '@/vue/blocks/ImageTextBlock/imageTextBlock'
import WideImageBlock from '@/vue/blocks/WideImageBlock/wideImageBlock'
import ImageVideoBlock from '@/vue/blocks/ImageVideoBlock/imageVideoBlock'
import VideoBlock from '@/vue/blocks/VideoBlock/videoBlock'
import AlertBlock from '@/vue/blocks/AlertBlock/alertBlock'
import ContactBlock from '@/vue/blocks/ContactBlock/contactBlock'
import InfoPostBlock from '@/vue/blocks/InfoPostBlock/infoPostBlock'
import TestimonialBlock from '@/vue/blocks/TestimonialBlock/testimonialBlock'
import ArticleRecipeBlock from "@/vue/blocks/ArticleRecipeBlock/articleRecipeBlock"
import SubscribeBlock from '@/vue/blocks/SubscribeBlock/subscribeBlock'
import SupplierBlock from '@/vue/blocks/SupplierBlock/supplierBlock'
import UnsubscribeBlock from '@/vue/blocks/UnsubscribeBlock/unsubscribeBlock'
import GroceryBagBlock from '@/vue/blocks/GroceryBagBlock/groceryBagBlock'
import TeaserCollectionBlock from "@/vue/blocks/TeaserCollectionBlock/teaserCollectionBlock"
import ContainerListBlock from '@/vue/blocks/ContainerListBlock/containerListBlock'
import AuthorBlock from '@/vue/blocks/AuthorBlock/authorBlock'

// Molecules
import { IcaAccordion, IcaRating, IcaTechnicalError } from "~/@ica/ica-molecules-vue/src/components"
import IcaHeader from '@/vue/components/topNav/topNav'
import IcaFooter from '@/vue/components/footerNav/footerNav'

Vue.component("IcaHeader", IcaHeader)
Vue.component("IcaFooter", IcaFooter)
Vue.component("ArticleRecipeBlock", ArticleRecipeBlock)
Vue.component("UspBlock", UspBlock)
Vue.component("HeroBlock", HeroBlock)
Vue.component("NavigationBlock", NavigationBlock)
Vue.component("NavigationGroupBlock", NavigationGroupBlock)
Vue.component("TitleTextBlock", TitleTextBlock)
Vue.component("ConversionBlock", ConversionBlock)
Vue.component("OverviewNavigationBlock", OverviewNavigationBlock)
Vue.component("IllustrativeLinksBlock", IllustrativeLinksBlock)
Vue.component("AccordionBlock", IcaAccordion)
Vue.component("TechnicalError", IcaTechnicalError)
Vue.component("ProductBlock", ProductBlock)
Vue.component("PromoteProductBlock", PromoteProductBlock)
Vue.component("ManualOfferBlock", OfferBlock)
Vue.component("IcaRating", IcaRating)
Vue.component("FactBlock", FactBlock)
Vue.component("ImageTextBlock", ImageTextBlock)
Vue.component("WideImageBlock", WideImageBlock)
Vue.component("VideoBlock", VideoBlock)
Vue.component("AlertBlock", AlertBlock)
Vue.component("InfoPostBlock", InfoPostBlock)
Vue.component("ContactBlock", ContactBlock)
Vue.component("GroceryBagBlock", GroceryBagBlock)
Vue.component("ImageVideoBlock", ImageVideoBlock)
Vue.component("TestimonialBlock", TestimonialBlock)
Vue.component("SubscribeBlock", SubscribeBlock)
Vue.component("SupplierBlock", SupplierBlock)
Vue.component("UnsubscribeBlock", UnsubscribeBlock)
Vue.component("TeaserCollectionBlock", TeaserCollectionBlock)
Vue.component("ContainerListBlock", ContainerListBlock)
Vue.component("AuthorBlock", AuthorBlock)


/*-----------------------------
 * DEVELOPMENT SPECIFIC IMPORTS
  -----------------------------*/
if (process.env.NODE_ENV !== "production") {
  console.log(
    "WE ARE IN DEVELOPMENT BECAUSE process.env.NODE_ENV = ",
    process.env.NODE_ENV
  )
  // Add components and other plugins / mixins here that should only be available in dev
}
// #endregion
